import styles from './PlanningDocumentsBlock.module.css';

export type PlanningDocumentLink = {
  type: string;
  title: string;
  url: string;
  plan_ref?: string;
};

type Props = {
  documents: PlanningDocumentLink[];
  title: string;
  emptyHint?: string;
};

export default function PlanningDocumentsBlock({ documents, title, emptyHint }: Props) {
  if (!documents.length) {
    return emptyHint ? (
      <p className={styles.empty} data-testid="planning-documents-empty">
        {emptyHint}
      </p>
    ) : null;
  }

  return (
    <section className={styles.block} data-testid="planning-documents">
      <h2 className={styles.title}>{title}</h2>
      <ul className={styles.list}>
        {documents.map((doc) => (
          <li key={doc.url}>
            <a
              className={styles.docLink}
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.docIcon} aria-hidden>
                📄
              </span>
              <span className={styles.docText}>
                <span className={styles.docTitle}>{doc.title}</span>
                {doc.plan_ref ? <span className={styles.ref}>{doc.plan_ref}</span> : null}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
